import * as Yup from "yup";
import { noEmojiTest } from "../../../validations";

export const offcyclePayloadSchema = Yup.object().shape({
  paymentSettings: Yup.object().shape({
    payPeriodId: Yup.string().required("Pay date is required"),
    notes: noEmojiTest,
  }),
});
